import { StringParam } from 'use-query-params'
import { type QueryParamEncodedType } from './queryParams.types'

type BaseType = string | undefined

const makeEncoder =
  <TResult extends BaseType>() =>
  (inputValue: TResult | undefined): QueryParamEncodedType =>
    StringParam.encode(inputValue)

const makeDecoder =
  <TResult extends BaseType>() =>
  (queryStr: QueryParamEncodedType): TResult | undefined => {
    if (!queryStr) return undefined

    return StringParam.decode(queryStr) as TResult
  }

export const makeGenericStringQueryParamEncoder = <TResult extends BaseType>() => ({
  encode: makeEncoder<TResult>(),
  decode: makeDecoder<TResult>(),
})

export const stringQueryParamEncoder = makeGenericStringQueryParamEncoder<BaseType>()
